import { Location } from 'vue-router'


const ADMIN_AUTH_ID = '/auth/admin'
const ADMIN_LK_ID = '/lk/admin'
const ADMIN_COLLECTOR_ID = '/collector/admin'
const ADMIN_MARKS_ID = '/marks/admin'

const SERVICE_LK_ID = '/lk'
const SERVICE_ANALYTICS_ID = 'analytics/service'
const SERVICE_TESTS_ID = 'tests/service'

export type MenuFolder =
  | {
    name: string;
    route: Location;
    title: string;
    icon: string;
    iconClass: string;
  }
  | {
    name: string;
    href: string;
    target: '_blank';
    disabled: boolean;
    title: string;
    icon: string;
    iconClass: string;
  }

export const ADMIN_AUTH = {
  name: ADMIN_AUTH_ID,
  route: { name: ADMIN_AUTH_ID },
  title: 'Авторизация',
  icon: 'mdi-folder-key-outline',
  iconClass: 'secondary',
} as const

export const ADMIN_LK = {
  name: ADMIN_LK_ID,
  route: { name: ADMIN_LK_ID },
  title: 'Личный кабинет',
  icon: 'mdi-folder-account-outline',
  iconClass: 'secondary',
} as const

export const ADMIN_COLLECTOR = {
  name: ADMIN_COLLECTOR_ID,
  route: { name: ADMIN_COLLECTOR_ID },
  title: 'Коллектор',
  icon: 'mdi-folder-account-outline',
  iconClass: 'secondary',
} as const

export const ADMIN_MARKS = {
  name: ADMIN_MARKS_ID,
  route: { name: ADMIN_MARKS_ID },
  title: 'Оценки',
  icon: 'mdi-folder-account-outline',
  iconClass: 'secondary',
} as const

export const SERVICE_LK = {
  name: SERVICE_LK_ID,
  route: { name: SERVICE_LK_ID },
  disabled: process.env.VUE_APP_SERVICE_LK_ENABLED === 'false',
  title: 'Личный кабинет',
  icon: 'mdi-account-outline',
  iconClass: 'secondary',
} as const

export const SERVICE_ANALYTICS = {
  name: SERVICE_ANALYTICS_ID,
  href: process.env.VUE_APP_SERVICE_ANALYTICS_URL,
  target: '_blank',
  disabled: process.env.VUE_APP_SERVICE_ANALYTICS_ENABLED === 'false',
  title: 'Аналитика',
  icon: 'mdi-chart-areaspline',
  iconClass: 'secondary',
} as const

export const SERVICE_TESTS = {
  name: SERVICE_TESTS_ID,
  href: process.env.VUE_APP_SERVICE_TESTS_URL,
  target: '_blank',
  disabled: process.env.VUE_APP_SERVICE_TESTS_ENABLED === 'false',
  title: 'Тестирование',
  icon: 'mdi-flask',
  iconClass: 'secondary',
} as const
